import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import i18next from "i18next";
import { selectCalendarDate, setCalendarDate } from "../store/dashboard.duck";

export function WithDateLocale() {
  const dispatch = useDispatch();
  const calendarDate = useSelector(selectCalendarDate);

  const updateLocale = useCallback(() => {
    const lang = i18next.language || 'en';
    if (calendarDate.locale() !== lang) {
      moment.locale(lang);
      dispatch(setCalendarDate(calendarDate.locale(lang)));
    }
  }, [calendarDate, dispatch])

  useEffect(() => {
    const onLanguageChanged = () => updateLocale();
    i18next.on('languageChanged', onLanguageChanged);
    return () => { i18next.off('languageChanged', onLanguageChanged); };
  }, [updateLocale]);

  return {updateLocale: updateLocale};
}
